import { TrendingUp } from "lucide-react";

// Small social-proof strip for the homepage - matches the existing
// Hero status-pill styling (bg-primary/10, border-primary/20).
export function ClientTrustBadge() {
  return (
    <div className="w-full flex justify-center py-6 md:py-10">
      <div className="inline-flex items-center gap-2.5 px-4 py-2 md:px-5 md:py-2.5 rounded-full bg-primary/10 border border-primary/20 backdrop-blur-sm text-xs md:text-sm text-muted-foreground">
        <TrendingUp className="w-4 h-4 text-primary shrink-0" />
        <span>
          Currently building for a{" "}
          <strong className="text-foreground font-semibold">₹100 Cr+ revenue</strong>{" "}
          business conglomerate
        </span>
      </div>
    </div>
  );
}
